export const setCurrentFilterValuesReducer = (state, action) => {
    if (!state?.editor) {
        return;
    }
    if (!state.editor.settings) {
        state.editor.settings = {};
    }
    if (!state.editor.settings.widgetFilterValues) {
        state.editor.settings.widgetFilterValues = {};
    }
    for (const payload of action.payload) {
        const { filter, values } = payload;
        if (state.editor.settings?.widgetFilterValues && values.length !== 0) {
            state.editor.settings.widgetFilterValues[filter] = values;
        }
        else {
            delete state.editor.settings.widgetFilterValues[filter];
        }
    }
};
